import { render } from "./MessagePresenter.vue?vue&type=template&id=68aa310c"
import script from "./MessagePresenter.vue?vue&type=script&lang=js"
export * from "./MessagePresenter.vue?vue&type=script&lang=js"

import "./MessagePresenter.vue?vue&type=style&index=0&id=68aa310c&lang=css"
script.render = render

export default script